import { useMemo } from 'react';
import { isType } from 'variant';
import { useProjectModel } from '../model.js';
import { DevCenterComponent } from '../dev-center/components/dev-center-component.js';

export function useBackendComponents() {
  const { model } = useProjectModel();

  const backendComponentsByType = useMemo(() => {
    const Api = model.components
      .filter(isType(DevCenterComponent.Api))
      .sort((a, b) => a.title.localeCompare(b.title));

    const WebMethod = model.components
      .filter(isType(DevCenterComponent.WebMethod))
      .sort((a, b) => a.relativePath.localeCompare(b.relativePath));

    const Event = model.components
      .filter(isType(DevCenterComponent.Event))
      .sort((a, b) => a.title.localeCompare(b.title));

    const ServicePlugin = model.components
      .filter(isType(DevCenterComponent.ServicePlugin))
      .sort((a, b) => a.servicePlugin.name.localeCompare(b.servicePlugin.name));

    return {
      Api,
      WebMethod,
      Event,
      ServicePlugin,
    };
  }, [model.components]);

  return {
    backendComponents: [
      ...backendComponentsByType.Api,
      ...backendComponentsByType.WebMethod,
      ...backendComponentsByType.Event,
      ...backendComponentsByType.ServicePlugin,
    ],
    backendComponentsByType,
  };
}
